import { AllowedKeys } from '../../ui/atoms/TextArea/typings';
import getDisputes from '../../redux/allDisputes/getDisputes';
import postCancelDispute from '../../redux/cancelDispute/patchCancelDispute';
import { t } from '../../strings/i18n/i18n';
export var handleTextChange = function (props) {
    var e = props.e, setOtherReason = props.setOtherReason, setOtherReasonError = props.setOtherReasonError, maxCharactersReached = props.maxCharactersReached, keyChar = props.keyChar;
    var inputValue = e.target.value;
    if (inputValue === null || inputValue === void 0 ? void 0 : inputValue.trim()) {
        setOtherReasonError('');
    }
    if (!inputValue || (inputValue === null || inputValue === void 0 ? void 0 : inputValue.trim())) {
        if (maxCharactersReached &&
            (keyChar === AllowedKeys.Backspace ||
                keyChar === AllowedKeys.Delete ||
                keyChar === AllowedKeys.ArrowUp ||
                keyChar === AllowedKeys.ArrowDown ||
                keyChar === AllowedKeys.ArrowLeft ||
                keyChar === AllowedKeys.ArrowRight)) {
            return setOtherReason(inputValue);
        }
        return setOtherReason(inputValue);
    }
    return null;
};
export var primaryButtonHandler = function (props) {
    var fireCloseModal = props.fireCloseModal, dispatch = props.dispatch, isCancelSubmitted = props.isCancelSubmitted, selectedOption = props.selectedOption, setShowError = props.setShowError, setOtherReasonError = props.setOtherReasonError, otherReason = props.otherReason, caseId = props.caseId, transactionId = props.transactionId, accountId = props.accountId;
    // Close the modal and refetch disputes if this function is called from cancel dispute status page
    if (isCancelSubmitted) {
        fireCloseModal();
        dispatch(getDisputes(accountId));
        return;
    }
    if (!selectedOption) {
        setShowError(true);
    }
    else if (selectedOption === 'reason5' && !otherReason) {
        setOtherReasonError("".concat(t('formError.cancelReason')));
    }
    else {
        var selectedReason = selectedOption === 'reason5'
            ? otherReason
            : t("cancelDispute.".concat(selectedOption));
        var cancelDisputeRequest = {
            caseId: caseId,
            transactionId: transactionId,
            reason: selectedReason
        };
        dispatch(postCancelDispute(cancelDisputeRequest));
    }
};
//# sourceMappingURL=handlers.js.map